/**
 * @typedef {String} module:EventService.GarageDoorActionEnum
 * @readonly
 * @description Garage door actions
 * @property {String} open
 * @property {String} close
 */
const garageDoorActionEnum = Object.freeze({
    open: 'open',
    close: 'close'
});

export default garageDoorActionEnum;
